module.exports = __webpack_public_path__ + "img/initial-strategy.90925535.png";